import { __assign } from "tslib";
// DS: C16A
/** An editor content viewer for comments */
import React from 'react';
import BaseViewer from './Base';
import commentsTheme from '../Themes/Viewer/comments.scss';
var CommentViewer = function (props) {
    return (React.createElement("div", { className: 'da-editor-comments' },
        React.createElement(BaseViewer, __assign({ theme: commentsTheme, showMediaAlwaysSmall: true, fixedParagraph: false }, props))));
};
export default CommentViewer;
//# sourceMappingURL=Comment.js.map